import React from 'react'

export default function intercomUpdate (attrs) {
  return function decorator (Target) {
    return class Wrapped extends React.Component {
      componentDidMount () {
        this.props.rootStore.intercomStore.update(attrs)
      }

      render () {
        return (
          <Target {...this.props} />
        )
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/client/decorators/intercomUpdate.js